import { HabitatTheme as p, vars as h } from "./theme.js";
import { B as g, H as m, a as x, b as k, c as y, d as w, e as H, I as B } from "./Typography-2ZjCxfuP.js";
import { B as j } from "./Button-BNj0TeuP.js";
import { B as C } from "./Badge-BE18ezuy.js";
import { S as I } from "./Switch-BoUWWFW5.js";
import { C as $ } from "./Checkbox-CIt7C3d4.js";
const a = {
  space: {
    0: 0,
    25: 2,
    50: 4,
    75: 6,
    100: 8,
    125: 10,
    150: 12,
    175: 14,
    200: 16,
    225: 18,
    250: 20,
    300: 24,
    400: 32,
    500: 40,
    600: 48,
    800: 64,
    1e3: 80,
    1800: 144
  },
  corner: {
    50: 4,
    100: 8,
    200: 16,
    300: 24,
    400: 32,
    1e3: 800
  },
  foreground: {
    critical: {
      default: "#eb5757ff",
      light: "#fdeeeeff"
    },
    success: {
      default: "#7dbe64ff",
      background: "#f2f9efff"
    },
    warning: {
      default: "#f5c35cff",
      light: "#fef9edff"
    },
    text: {
      primary: "#1d1d1bff",
      secondary: "#525251ff",
      inverted: "#ffffffff",
      hover: "#737372ff",
      placeholder: "#b3b3b2ff"
    },
    border: {
      default: "#b3b3b2ff",
      "hover, active": "#ff991fff",
      critical: "#eb5757ff",
      disabled: "#e8e8e8ff"
    },
    surface: {
      disabled: "#f5f5f5ff",
      default: "#ffffffff",
      "pressed, active": "#fff5e9ff"
    }
  },
  root: {
    orange: {
      300: "#fff5e9ff",
      400: "#ffc279ff",
      500: "#ff991fff",
      600: "#e68a1cff",
      700: "#c17e34ff"
    },
    darkgreen: {
      300: "#edf2f1ff",
      400: "#cdd8d7ff",
      500: "#063d39ff",
      600: "#05332fff",
      700: "#021a18ff"
    },
    teal: {
      500: "#25c1a3ff"
    },
    neutral: {
      0: "#ffffffff",
      50: "#f5f5f5ff",
      100: "#e8e8e8ff",
      200: "#d4d4d3ff",
      300: "#b3b3b2ff",
      400: "#737372ff",
      500: "#525251ff",
      600: "#1d1d1bff"
    },
    red: {
      100: "#fdeeeeff",
      200: "#f39a9aff",
      300: "#ff5e5eff",
      400: "#eb5757ff",
      500: "#c45753ff",
      600: "#ae4e4aff"
    },
    green: {
      100: "#f2f9efff",
      200: "#afd7a0ff",
      300: "#95cb82ff",
      400: "#7dbe64ff",
      500: "#71ab5aff",
      600: "#649850ff"
    },
    yellow: {
      100: "#fef9edff",
      200: "#f9da98ff",
      300: "#f7cf79ff",
      400: "#f5c35cff",
      500: "#ddaf52ff",
      600: "#c49c49ff"
    },
    offwhite: {
      100: "#f6f6f1ff"
    },
    glass: {
      100: "#e0f4fdff"
    }
  },
  background: {
    default: {
      light: "#ffffffff",
      dark: "#f6f6f1ff"
    },
    primary: {
      dark: "#ff991fff",
      light: "#fff5e9ff"
    },
    secondary: {
      dark: "#063d39ff",
      light: "#edf2f1ff"
    }
  },
  brand: {
    primary: "#ff991fff",
    secondary: "#063d39ff",
    accent: "#25c1a3ff",
    "primary-light": "#fff5e9ff",
    "secondary-light": "#edf2f1ff"
  }
}, o = {
  light: {
    text: {
      primary: "#1d1d1bff",
      inverted: "#ffffffff",
      disabled: "#737372ff",
      round: "#1d1d1bff"
    },
    background: {
      default: "#1d1d1bff",
      inverted: "#ffffffff",
      hover: "#737372ff",
      "hover-tertiary": "#e8e8e8ff",
      "active, pressed": "#525251ff",
      disabled: "#e8e8e8ff",
      "round-default": "#e8e8e8ff",
      "round-hover": "#d4d4d3ff"
    },
    border: {
      default: "#1d1d1bff",
      hover: "#737372ff",
      "active, pressed": "#525251ff",
      disabled: "#e8e8e8ff",
      "hover-tertiary": "#e8e8e8ff",
      "round-default": "#ffffffff",
      "round-hover": "#f5f5f5ff"
    }
  },
  dark: {
    text: {
      primary: "#ffffffff",
      inverted: "#1d1d1bff",
      disabled: "#737372ff",
      round: "#1d1d1bff"
    },
    background: {
      default: "#ffffffff",
      inverted: "#737372ff",
      hover: "#e8e8e8ff",
      "hover-tertiary": "#e8e8e8ff",
      "active, pressed": "#d4d4d3ff",
      disabled: "#e8e8e8ff",
      "round-default": "#ffffffff",
      "round-hover": "#f5f5f5ff"
    },
    border: {
      default: "#ffffffff",
      hover: "#e8e8e8ff",
      "active, pressed": "#525251ff",
      disabled: "#e8e8e8ff",
      "hover-tertiary": "#e8e8e8ff",
      "round-default": "#ffffffff",
      "round-hover": "#f5f5f5ff"
    }
  }
}, f = {
  foundations: a,
  buttons: o
}, s = {
  background: f.foundations.background,
  brand: f.foundations.brand,
  buttons: f.buttons,
  foreground: f.foundations.foreground,
  root: f.foundations.root
}, n = f.foundations.corner, i = Object.entries(n).reduce((e, [d, r]) => (e[d] = `${r}px`, e), {}), t = f.foundations.space;
[...Object.values(t)].map(String);
const c = Object.entries(t).reduce(
  (e, [d, r]) => (e[d] = `${r}px`, e),
  {}
), b = {
  desktop: "(min-width: 1024px)",
  desktopHD: "(min-width: 1440px)",
  desktopSD: "(min-width: 960px)",
  mobile: "(min-width: 360px)",
  tablet: "(min-width: 768px)"
};
export {
  C as Badge,
  g as Body,
  j as Button,
  $ as Checkbox,
  m as H1,
  x as H2,
  k as H3,
  y as H4,
  w as H5,
  H as H6,
  p as HabitatTheme,
  B as Inline,
  I as Switch,
  s as colors,
  i as corners,
  b as mq,
  c as space,
  h as vars
};
//# sourceMappingURL=index.js.map
